// Order API
import ajax from './_ajax';

const api = {};
// ShoppingCart
api.getShoppingCart = function () {
  return ajax.get('/api/ShoppingCart/GetAll');
};
api.deleteShoppingCart = function (id) {
  return ajax.post('/api/ShoppingCart/Delete?id=' + id);
};
api.batchDeleteShoppingCart = function (params) {
  return ajax.post('/api/ShoppingCart/BatchDelete', params);
};
api.updateShoppingCart = function (params) {
  return ajax.post('/api/ShoppingCart/Update', params);
};
api.addShoppingCart = function (params) {
  return ajax.post('/api/ShoppingCart/Add', params);
};
api.addMoreShoppingCart = function (obj) {
  return ajax.post('api/ShoppingCart/AddMore', obj);
};

api.getAttributesByProductId = function (id) {
  return ajax.get('/api/ProductAttribute/GetAttributesByProductId?id=' + id);
};
api.getAdditionalServicesByProductId = function (id) {
  return ajax.get('/api/ProductAdditionalService/GetAdditionalServicesByProductId?id=' + id);
};
api.getPagedOrders = function (params) {
  return ajax.post('/api/Order/GetPagedOrders', params);
};
api.searchPurchaseProducts = function (params) {
  return ajax.post('/api/Order/SearchPurchaseProducts', params);
};
api.getAllShipsByOrderId = function (id) {
  return ajax.get('/api/Ship/GetAllShipsByOrderId?orderId=' + id);
};
api.getLogisticsInfo = function (params) {
  return ajax.post('/api/Logistics/GetLogisticsInfo', params);
};
export default api;



// WEBPACK FOOTER //
// ./src/api/orderApi.js